import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { gql } from "@apollo/client";
import { DateTime } from "luxon";
import { VariantOption, useUpdateVariantSelect, ChooseProductSelection, benefitFulfillmentText } from "@withfriendsco/wf-components";
import { useWelcomeGiftVariantQuery } from "types";
gql `
query WelcomeGiftVariant($id: ID!) {
  fulfillment(id: $id) {
    id
    isGift
    fulfillmentDate
    fulfillmentDateAdjustmentReason
    ...SaveFulfillmentSettings
    benefit {
      id
      ... on SubscriptionBenefit {
        shippingIncluded
        deliveredToYour
      }
      name
      products {
        ...ChooseSubscriptionScreenProduct
      }
      variants {
        ...ChooseSubscriptionScreenVariant
      }
    }
    membership {
      purchaser {
        id
        firstName
        lastName
      }
      user {
        id
        firstName
        lastName
      }
    }
    platformLineItems {
      quantity
      platformProductVariantId
      swapped
    }
  }
}
`;
const WelcomeGiftVariant = ({ id }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    const updateVariantSelect = useUpdateVariantSelect(id);
    const { data, loading, error } = useWelcomeGiftVariantQuery({
        variables: {
            id,
        }
    });
    if (!data)
        return null;
    const fulfillmentDate = DateTime.fromSQL(data.fulfillment.fulfillmentDate);
    return (_jsxs("div", { className: "font-sans w-full max-w-xl mb-7 pb-6 border-b-2 border-wfGray-300", children: [_jsxs("p", { className: "mb-4 block text-m", children: ["As a new member, you'll receive a ", _jsx("strong", { children: data.fulfillment.benefit.name }), " \u2013 a little welcome from us to you!"] }), ((_a = data === null || data === void 0 ? void 0 : data.fulfillment) === null || _a === void 0 ? void 0 : _a.isGift) &&
                ((_d = (_c = (_b = data === null || data === void 0 ? void 0 : data.fulfillment) === null || _b === void 0 ? void 0 : _b.membership) === null || _c === void 0 ? void 0 : _c.purchaser) === null || _d === void 0 ? void 0 : _d.id) && (_jsxs("div", { className: "my-4 block", children: ["Purchaser: ", (_f = (_e = data.fulfillment.membership) === null || _e === void 0 ? void 0 : _e.purchaser) === null || _f === void 0 ? void 0 : _f.firstName, " ", (_h = (_g = data.fulfillment.membership) === null || _g === void 0 ? void 0 : _g.purchaser) === null || _h === void 0 ? void 0 : _h.lastName] })), _jsxs("div", { className: "my-4 block", children: ["Member: ", (_j = data.fulfillment.membership) === null || _j === void 0 ? void 0 : _j.user.firstName, " ", (_k = data.fulfillment.membership) === null || _k === void 0 ? void 0 : _k.user.lastName] }), _jsxs("div", { className: "block text-wfGray-800", children: [benefitFulfillmentText(data.fulfillment.benefit)('fulfillment_date'), ": ", fulfillmentDate.toLocaleString()] }), data.fulfillment.benefit.products.filter((product) => product.variants.length).map((product) => {
                return (_jsx(ChooseProductSelection, { product: product, productSelection: data.fulfillment.productSelections.find((productSelection) => productSelection.product.id == product.id), fulfillmentId: id }, product.id));
            }), (data.fulfillment.benefit.variants || []).length > 0 ? (_jsxs(_Fragment, { children: [_jsx("h4", { className: "my-4 block pt-4", children: "Options" }), _jsxs("select", { onChange: updateVariantSelect, value: (_m = (_l = data.fulfillment) === null || _l === void 0 ? void 0 : _l.variant) === null || _m === void 0 ? void 0 : _m.id, className: "p-2 w-full border border-wfGray-300 focus:border-salmon-600 focus:border-2 text-lg", children: [_jsx("option", { children: "Select a Welcome Gift!" }), (_q = (_p = (_o = data.fulfillment) === null || _o === void 0 ? void 0 : _o.benefit) === null || _p === void 0 ? void 0 : _p.variants) === null || _q === void 0 ? void 0 : _q.map((variant) => {
                                return _jsx(VariantOption, Object.assign({}, variant), variant.id);
                            })] })] })) : null] }));
};
export default WelcomeGiftVariant;
